module.exports = __webpack_public_path__ + "img/client-time-attack.630cf3ee.jpg";